export default {
  setupBrand: "Setup Brand Category",
  brandSpecialized: "What's your brand specialized in?",
};
